var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-product-library-agent-submenu'),_c('div',{staticClass:"q-sticky-buffer"},[_c('v-container',{staticClass:"px-5 grey lighten-5 site-width",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }